import React, { useState, useContext } from 'react';
import Content from '../components/Content';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import SearchRecords from '..//components/search';
import MasterList from 'components/list';
import SearchIcon from '@material-ui/icons/Search';
import LoopIcon from '@material-ui/icons/Loop';
import ForProcessing from 'components/ForProcessing';
import { UserContext } from '../contexts';


const options = [
	'Create',
	'Back'
];

const ITEM_HEIGHT = 48;

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`scrollable-force-tabpanel-${index}`}
			aria-labelledby={`scrollable-force-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box>
					{children}
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `scrollable-force-tab-${index}`,
		'aria-controls': `scrollable-force-tabpanel-${index}`,
	};
}

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		width: '100%',
		backgroundColor: theme.palette.background.paper,
	}
}));



const QrDetails = () => {
	const context = useContext(UserContext);

	const classes = useStyles();
	const [value, setValue] = React.useState(0);

	const history = useHistory();

	const [rowsToPush, setRowsToPush] = useState([]);
	const [selectedRawEdit, setSelectedRawEdit] = useState({});
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (e) => {
		console.log(e.target.textContent);
		switch (e.target.textContent) {
			case 'Back':
				history.goBack();
				break;
			default:
		}

		setAnchorEl(null);
	};

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	


	return (
		<Content>
			<div>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"
					onClick={handleClick}
				>
					<MoreVertIcon />
				</IconButton>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"

				>
					<span>QR Code</span>
				</IconButton>

				<Menu
					id="long-menu"
					anchorEl={anchorEl}
					keepMounted
					open={open}
					onClose={handleClose}
					PaperProps={{
						style: {
							maxHeight: ITEM_HEIGHT * 5,
							width: '20ch',
						},
					}}
				>
					{options.map((option) => (
						<MenuItem key={option} selected={option === 'Pyxis'} onClick={(e) => handleClose(e)}>
							{option}
						</MenuItem>
					))}
				</Menu>
			</div>

			<AppBar position="static" color="default">
				<Tabs
					value={value}
					onChange={handleChange}
					variant="scrollable"
					scrollButtons="on"
					indicatorColor="primary"
					textColor="primary"
					aria-label="scrollable force tabs example"
				>
					<Tab label="Search" icon={<SearchIcon />} {...a11yProps(0)} />
					<Tab label="Local Storage" icon={<ShoppingBasket />} {...a11yProps(1)} />
					<Tab label="For Processing" icon={<LoopIcon />} {...a11yProps(2)} />
					
				</Tabs>
			</AppBar>
			<TabPanel value={value} index={0}>
				<h3>Search Item</h3>
				<SearchRecords />
			</TabPanel>
			<TabPanel value={value} index={1}>
				<h3>Local Storage</h3>
				<MasterList />
			</TabPanel>
			<TabPanel value={value} index={2}>
				<h3>For Processing</h3>
				<ForProcessing />

			</TabPanel>


		</Content>
	);
};

export default QrDetails;
